import { atom } from "jotai";

export const newlyCreatedCampaignIdAtom = atom<number | null>(null);
